import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, WritableSignal, computed, model, signal } from '@angular/core';
import { TripActualHistoryGraphComponent } from '../trip-actual-history-graph/trip-actual-history-graph.component';
import { UiModule } from "../../../ui/ui.module";
import { LinkableLocationsService, ProfileLocation } from 'src/app/api/linkable-locations.service';
import { Options } from 'src/app/ui/dropdowns/dropdown-option.service';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
    selector: 'app-trip-actual-history-report',
    imports: [TripActualHistoryGraphComponent, UiModule],
    templateUrl: './trip-actual-history-report.component.html',
    styleUrl: './trip-actual-history-report.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TripActualHistoryReportComponent implements OnInit {


  yearOptions = [2019, 2020, 2021, 2022, 2023, 2024, 2025]
  locationOptions: WritableSignal<ProfileLocation[]> = signal([])


  // location = model<string>()
  locations = model<ProfileLocation[]>([])
  selectedYears = model<number[]>([2019, 2020, 2021, 2022, 2023, 2024, 2025])

  loading = signal<boolean>(true)

  locationList = computed(() => {
    return this.locations().map(l => l.name).join(", ")
  })

  constructor(
    private locationService: LinkableLocationsService,
    private chRef: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    this.locationService.getLocations("active").subscribe(result => {
      this.locationOptions.set([...result.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))])
    })
    this.chRef.detectChanges()
  }

  chartLoading(loading: boolean) {
    this.loading.set(loading)
  }

}
